// Google maps triggers a callback. This triggers an event.
const $ = window.jQuery;
window.iecInitGoogleMaps = function() {
	$( window ).trigger( 'iecInitGoogleMaps' );
}
